import { Card } from "@/components/ui/card";

export default function Privacy() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="max-w-2xl w-full p-8 shadow-lg border border-border bg-card">
        <h1 className="text-3xl font-bold mb-4 text-foreground">
          Privacy Policy
        </h1>
        <p className="mb-4 text-foreground">
          Your privacy is important to us. This policy explains how we collect,
          use, and protect your information.
        </p>
        <ul className="list-disc pl-6 space-y-2 text-foreground">
          <li>
            We collect only the information necessary to provide our services
            and improve your experience.
          </li>
          <li>
            Your personal information is stored securely and is not shared with
            third parties except as required by law.
          </li>
          <li>
            <strong>We do not sell your information to anyone.</strong>
          </li>
          <li>
            You may request to view, update, or delete your personal information
            at any time.
          </li>
          <li>
            We may update this policy periodically. Continued use of the
            application constitutes acceptance of any changes.
          </li>
        </ul>
        <p className="mt-6 text-foreground">
          For questions or concerns about your privacy, please contact our
          support team.
        </p>
      </Card>
    </div>
  );
}
